"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _consts = require("../consts");

var calculatePopoverPosition = function calculatePopoverPosition(preferredPosition, preferredHoriznotalPosition) {
  var mappedPositions = Object.keys(_consts.POSITIONS).map(function (k) {
    return _consts.POSITIONS[k];
  });
  var mappedAlignPositions = Object.keys(_consts.ALIGNS).map(function (k) {
    return _consts.ALIGNS[k];
  });
  return [[preferredPosition].concat((0, _toConsumableArray2.default)(mappedPositions.filter(function (p) {
    return p !== preferredPosition;
  }))), [preferredHoriznotalPosition].concat((0, _toConsumableArray2.default)(mappedAlignPositions.filter(function (p) {
    return p !== preferredHoriznotalPosition;
  })))];
};

var _default = calculatePopoverPosition;
exports.default = _default;